import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, Transition as _Transition, withCtx as _withCtx, createVNode as _createVNode, withModifiers as _withModifiers, renderList as _renderList, Fragment as _Fragment, resolveComponent as _resolveComponent, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "mt-2 border-primary-main border-t-2 border-b-1 border-l-8 shadow-sm" }
const _hoisted_2 = { class: "h-20 p-3 flex justify-between" }
const _hoisted_3 = { class: "flex" }
const _hoisted_4 = ["src"]
const _hoisted_5 = { class: "text-primary-main font-medium h-10 leading-10 mt-2 text-center inline-block" }
const _hoisted_6 = { class: "shadow rounded-full w-10 h-10" }
const _hoisted_7 = {
  key: 0,
  class: "text-gray-400 text-center h-10 leading-10 inline-block"
}
const _hoisted_8 = {
  key: 1,
  class: "text-gray-400 text-center h-10 leading-10 inline-block"
}
const _hoisted_9 = {
  key: 0,
  class: "p-2"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ExchangeCard = _resolveComponent("ExchangeCard")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("a", {
      href: "#",
      class: "cursor-pointer",
      onClick: _cache[0] || (_cache[0] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.toggle && _ctx.toggle(...args)), ["prevent"]))
    }, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          (_ctx.thumbnail_image_url)
            ? (_openBlock(), _createElementBlock("img", {
                key: 0,
                src: _ctx.thumbnail_image_url,
                class: "w-auto h-full mr-2"
              }, null, 8, _hoisted_4))
            : _createCommentVNode("", true),
          _createElementVNode("text", _hoisted_5, _toDisplayString(_ctx.title), 1)
        ]),
        _createElementVNode("div", _hoisted_6, [
          _createVNode(_Transition, {
            name: "rotate",
            mode: "out-in"
          }, {
            default: _withCtx(() => [
              (_ctx.open)
                ? (_openBlock(), _createElementBlock("text", _hoisted_7, "▲"))
                : (_openBlock(), _createElementBlock("text", _hoisted_8, "▼"))
            ]),
            _: 1
          })
        ])
      ])
    ]),
    _createVNode(_Transition, { name: "open" }, {
      default: _withCtx(() => [
        (_ctx.open)
          ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.exchange_configs, (exchangeConfig, index) => {
                return (_openBlock(), _createBlock(_component_ExchangeCard, {
                  key: index,
                  exchangeConfig: exchangeConfig
                }, null, 8, ["exchangeConfig"]))
              }), 128))
            ]))
          : _createCommentVNode("", true)
      ]),
      _: 1
    })
  ]))
}